import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  DEFAULT_OVERVIEW_FILTERS,
  FilterStateOverview,
  UpdateOverviewFilterPayload,
} from "./types";

const initialState: FilterStateOverview = {
  filters: DEFAULT_OVERVIEW_FILTERS,
};

const overviewFilterSlice = createSlice({
  name: "overviewFilter",
  initialState,
  reducers: {
    updateFilter(
      state,
      action: PayloadAction<UpdateOverviewFilterPayload>,
    ): void {
      const { key, value } = action.payload;
      state.filters = { ...state.filters, [key]: value };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, resetFilters } = overviewFilterSlice.actions;
export default overviewFilterSlice.reducer;
